import {Transform} from "@/lib/helper";
import BubbleService from "../BubbleService";

class BlogService extends BubbleService {
  constructor() {
    super();
  }

  createBlog = async (formData:any) => {
    const transform = new Transform()
    const image = await transform.prepareDataForBubbleImageUpload(formData.image[0])
    const data = {
      content: formData.content,
      description: formData.description,
      image: image,
      raw: formData.raw,
      slug: formData.slug,
      title: formData.title,
      isSpecial: formData.isSpecial,
      category: formData.category,
      author: formData.author
    }
    const result = await this.postWf('create_blog',data);
    return '';
  };

  updateBlog = async (formData:any) => {
    if(formData.image && typeof formData.image != "string"){
      const transform = new Transform()
      formData.image = await transform.prepareDataForBubbleImageUpload(formData.image[0])
    }
    const data: any = {
      id: formData.id,
      content: formData.content,
      description: formData.description,
      raw: formData.raw,
      slug: formData.slug,
      title: formData.title,
      isSpecial: formData.isSpecial,
      category: formData.category,
      author: formData.author,
      image: formData.image
    }
    const result = await this.postWf('update_blog',data);
    return '';
  };


  createCategory = async (data:string) => {
    const result = await this.postWf('create_blog_category',{name:data})
    return result
  }

  getBlogList = async (cursor: any = 0,limit: any = 9,category: string = 'sitemap') => {
    let constraint:any = ''
    let result: any = {}
    if(category != 'sitemap'){
      if(category != "Tất cả"){
        constraint = [{key: 'category', constraint_type: 'equals', value: category}]
        constraint = JSON.stringify(constraint)
      }

      let queryString = `cursor=${cursor}&limit=${limit}${constraint ? `&constraints=${constraint}` : ''}&additional_sort_fields=[{"sort_field":"created date","descending":"true"}]`
      result = await this.getObj(`Blog?${queryString}`)
    }else{
      let queryString = `cursor=${cursor}&limit=${limit}`
      result = await this.getObj(`Blog?${queryString}`)
    }

    return result.results
  }

  getBlogSpecial = async () => {
    let constraint:any = ''
      constraint = [{key: 'isSpecial', constraint_type: 'equals', value: 'true'}]
      constraint = JSON.stringify(constraint)
    let queryString = `${constraint ? `&constraints=${constraint}` : ''}`
    // console.log(queryString)
    const result:any = await this.getObj(`Blog?${queryString}`)
    return result.results
  }

  getBlogDetail = async (slug: any) => {
    const result:any = await this.postWf(`detail_blog`,{slug})
    return result.result
  }

  getBlogDetailById = async (id: any) => {
    const result:any = await this.postWf(`detail_blog_by_id`,{id})
    return result.result
  }

  getBlogCategoryOption = async () => {
    const data:any = await this.getObj('Blog_Category')
    const result = data.results.map((item: { name: any; }) => {
      return {label: item.name,value: item.name}
    })
    return result
  }

  getBlogCategoryList = async () => {
    const data:any = await this.getObj('Blog_Category')
    return data.results
  }
}

export default BlogService;
